import { logs, SeverityNumber } from '@opentelemetry/api-logs';
import pino from 'pino';

const otelLogger = logs.getLogger('frontend-logger');

const getSeverityNumber = (level: number): SeverityNumber => {
  if (level <= 10) return SeverityNumber.TRACE;
  if (level <= 20) return SeverityNumber.DEBUG;
  if (level <= 30) return SeverityNumber.INFO;
  if (level <= 40) return SeverityNumber.WARN;
  if (level <= 50) return SeverityNumber.ERROR;
  return SeverityNumber.FATAL;
};

const getSeverityText = (level: number): string => {
  if (level <= 10) return 'trace';
  if (level <= 20) return 'debug';
  if (level <= 30) return 'info';
  if (level <= 40) return 'warn';
  if (level <= 50) return 'error';
  return 'fatal';
};

export const logger = pino({
  browser: {
    asObject: true,
    write: (o: any) => {
      const { level, time, msg, ...attributes } = o;
      const severityNumber = getSeverityNumber(level);
      const severityText = getSeverityText(level);

      otelLogger.emit({
        severityNumber,
        severityText,
        body: msg,
        attributes,
        timestamp: time || Date.now(),
      });

      // Also log to console for local development visibility
      // eslint-disable-next-line no-console
      const consoleMethod = (console as any)[severityText.toLowerCase()] || console.log;

      const timeStr = time ? new Date(time).toLocaleTimeString() : new Date().toLocaleTimeString();
      const label = `[${timeStr}] ${severityText.toLocaleUpperCase()}:`;

      if (Object.keys(attributes).length > 0) {
        consoleMethod(label, msg, attributes);
      } else {
        consoleMethod(label, msg);
      }
    },
  },
});
